import React from "react";
import { Modal, Divider } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import config from "../../../../config";
import { useSelector } from "react-redux";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextField, InputAdornment } from "@material-ui/core";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { useDispatch } from "react-redux";
import { useBilling } from "../../KOTbillingProvider";
import { useCountry, useCurrency } from "../../../../provider/courtryProvider";

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
  },
}));

const month = [
  { long: "January", short: "JAN" },
  { long: "Febrary", short: "FEB" },
  { long: "March", short: "MAR" },
  { long: "April", short: "APR" },
  { long: "May", short: "MAY" },
  { long: "June", short: "JUN" },
  { long: "July", short: "JUL" },
  { long: "August", short: "AUG" },
  { long: "September", short: "SEP" },
  { long: "October", short: "OCT" },
  { long: "November", short: "NOV" },
  { long: "December", short: "DEC" },
];

const CouponModal = ({ open, setOpen }) => {
  const classes = useStyles();
  const shopDetails = useSelector((state) => state.shopDetails);
  const dispatch = useDispatch();
  const [couponList, setCouponList] = React.useState([]);
  const [promoCode, setPromoCode] = React.useState("");
  const { getSubTotal } = useBilling();
  const handleClose = () => {
    setOpen(false);
  };
  const currencyFormatter = useCurrency();
  const billingPayload = useSelector((state) => state.billingPayload.data);
  const country = useCountry();

  const handleApplyCoupon = (coupon) => {
    const subTotal = getSubTotal();
    if (parseFloat(subTotal) >= parseFloat(coupon.condition.minPrice)) {
      setOpen(false);
      setPromoCode("");
      dispatch({
        type: "SET_COUPON",
        payload: coupon,
      });
      return;
    }
    alert(
      `Cannot Apply coupon. The bill value should be more than ${country.CurrencySymbol}.${coupon.condition.minPrice} to avail this coupon.`
    );
  };

  React.useEffect(() => {
    const fetchCoupons = async () => {
      var res = await fetch(
        `${config.newApiGateway}/coupon/create-Update-delete-get-coupon`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            action: "getAllCoupon",
            shopId: shopDetails.shopId,
          }),
        }
      );
      res = await res.json();
      console.log("res", res);
      if (res.code === "ERROR") {
        setCouponList([]);
        return;
      }
      if (res.code === "SUCCESS") {
        setCouponList(res.data);
      }
    };
    fetchCoupons();
  }, [shopDetails.shopId]);
  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={false}
      centered
      className={classes.modalStyle}
      width={660}
      closable={false}
    >
      <div>
        <button
          className="closebutton"
          onClick={() => {
            setOpen(false);
          }}
        >
          <CancelIcon />
        </button>
        <div
          className="couponheading"
          style={{ marginTop: 20, marginBottom: 5 }}
        >
          <div>
            <LocalOfferIcon style={{ fontSize: 20 }} />
          </div>
          <h3>Apply Coupons</h3>
        </div>
        <div>
          <TextField
            className="couponInput"
            placeholder="Enter your code"
            onChange={(e) => setPromoCode(e.target.value)}
            value={promoCode}
            style={{
              width: "100%",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <button
                    className="couponInputBtn"
                    disabled={couponList.length === 0 ? true : false}
                  >
                    Search
                  </button>
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />
        </div>
      </div>
      <Divider className={classes.dividerStyle} />
      {couponList.length > 0 ? (
        <>
          {couponList.map((data) => (
            <div className="cardContainer">
              <div className="cardDataContainer">
                <div className="couponCodeStyle">
                  <p>{data.promocode}</p>
                </div>
                <div className="coupounHeading">
                  <p>Get</p>
                </div>
                {data.discountType === "flat" ? (
                  <div className="couponOfferText">
                    <p>
                      {data.discountAmount}
                      {country.CurrencySymbol} OFF
                    </p>
                  </div>
                ) : (
                  <div className="couponOfferText">
                    <p>{data.discountAmount}% OFF</p>
                  </div>
                )}
                <div className="applyAndButton">
                  <div className="applyTextStyle">
                    <p className="couponApplyPurchase">
                      Apply on purchase worth{" "}
                      {currencyFormatter(data.condition.minPrice)} or more
                    </p>
                    <p className="couponApplyValid">
                      Valid from{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {new Date(data.startDate).getDate() +
                          " " +
                          month[new Date(data.startDate).getMonth()].short +
                          " " +
                          new Date(data.startDate).getFullYear()}
                      </span>{" "}
                      to{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {new Date(data.expiryDate).getDate() +
                          " " +
                          month[new Date(data.expiryDate).getMonth()].short +
                          " " +
                          new Date(data.expiryDate).getFullYear()}
                      </span>
                    </p>
                  </div>
                  <div className="applyBtnStyle">
                    {Object.keys(billingPayload.coupon).length > 0 &&
                    billingPayload.coupon.couponId === data.couponId ? (
                      <button
                        className="couponApplyBtn"
                        onClick={() => {
                          dispatch({
                            type: "SET_COUPON",
                            payload: {},
                          });
                        }}
                      >
                        Remove
                      </button>
                    ) : (
                      <button
                        className="couponApplyBtn"
                        onClick={() => handleApplyCoupon(data)}
                      >
                        Apply
                      </button>
                    )}
                  </div>
                </div>
                <div className="couponSaveCoupon">
                  <p>
                    You will save
                    {data.discountType === "flat" ? (
                      <> {currencyFormatter(data.discountAmount)}</>
                    ) : (
                      <> {data.discountAmount}%</>
                    )}{" "}
                    with this coupon
                  </p>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div
          className="cardContainer"
          style={{ textAlign: "center", marginTop: "20px", opacity: "0.5" }}
        >
          <p>No Coupons To Show</p>
        </div>
      )}
    </Modal>
  );
};

export default CouponModal;
